// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"f24232bc","2816":"ded46dcd","4226":"a3aec83c","4629":"ad18b764","9872":"ded46dcd"}[chunkId] + ".chunk.css";
};